export default function Main() {
    return (
        <main>
            <h1 className="div-h1">Fun facts about React!</h1>
            <ul className="div-ul">
                <li>Was first released in 2013</li>
                <li>Was originally created by Jordan Walke</li>
                <li>Has well over 190K stars 🌟 on <a href="https://github.com/facebook/react" rel="noopener noreferrer" target="_blank">GitHub</a></li>
                <li>Is maintained by <a href="https://opensource.fb.com/" rel="noopener noreferrer" target="_blank">Meta Open Source</a></li>
                <li>Powers thousands of enterprise apps, including mobile apps</li>
            </ul>
            <h3 className="div-h3">Learn more about <a href="https://reactjs.org" rel="noopener noreferrer" target="_blank">React</a></h3>
        </main>
    )
}